import { FETCH_GUIDES_SUCCESS, FETCH_SPECIFIC_GUIDE_SUCCESS } from 'Actions/guides'

const initialState = {
  guides: [],
  totalCount: 0,
  guide: {}
}

const guides = (state = initialState, action) => {
  const payload = action.payload

  switch (action.type) {
    case FETCH_GUIDES_SUCCESS:
      return {
        ...state,
        guides: payload.guides,
        totalCount: payload.totalCount
      }

    case FETCH_SPECIFIC_GUIDE_SUCCESS:
      return {
        ...state,
        guide: payload.guide
      }

    default:
      return state
  }
}

export default guides
